export default "__VITE_ASSET__B16NBH$v__"